import React from 'react';

import './BankAccountOnboarding.scss';

const CourierOnboarding = () => {
  const isProduction = window.location.origin.endsWith('porterbuddy.com');
  const dippsEnvSubDomain = isProduction ? 'my' : 'qa.my';
  const splitUrl = window.location.href.split('/onboarding');
  let suffix = splitUrl[splitUrl.length - 1];
  if (suffix.length === 0) {
    if (isProduction) {
      suffix = '/Sm9iLWU1MzQ2NmQzLTY1ZWItNDYwMS04OTRkLTRhOTg3OTg4ODVjZA=='; // Default courier job
    } else {
      suffix = '/Sm9iLWJlYTU5ZDBhLWM5ZDUtNDEzMi05MWI1LWYxMWZjZjNhNWI1Mw=='; // Job in QA env
    }
  }
  const dippsUrl = `https://${dippsEnvSubDomain}.manymore.com/nb/enrolment-wizard${suffix}`;

  return (
    <iframe
      className={'dippsIframe'}
      title={'Manymore courier onboarding form'}
      src={dippsUrl}
    />
  );
};

export default CourierOnboarding;
